/** Empty list = the contract covers every article of the work. */

export function uniquePositiveIds(ids: unknown): number[] {
    if (!Array.isArray(ids)) return [];
    const seen = new Set<number>();
    const result: number[] = [];
    for (const raw of ids) {
        const id = Number(raw);
        if (!Number.isInteger(id) || id <= 0 || seen.has(id)) continue;
        seen.add(id);
        result.push(id);
    }
    return result;
}

export function isWorkWideCoverage(coveredTitleIds: number[] | undefined | null): boolean {
    return !coveredTitleIds?.length;
}

export function normalizeCoveredTitleIds(selectedIds: number[], workTitleIds: number[]): number[] {
    const workSet = new Set(workTitleIds);
    const selected = uniquePositiveIds(selectedIds).filter((id) => workSet.has(id));
    if (selected.length === 0 || (workTitleIds.length > 0 && selected.length === workTitleIds.length)) {
        return [];
    }
    return selected;
}

export function termCoveragesConflict(a: number[], b: number[]): boolean {
    const aAll = isWorkWideCoverage(a);
    const bAll = isWorkWideCoverage(b);
    if (aAll && bAll) return true;
    if (aAll || bAll) return false;
    const other = new Set(b);
    return a.some((id) => other.has(id));
}
